import { useEffect } from 'react';
import { withLocalize } from 'react-localize-redux';
import { Container } from 'reactstrap';

import ForgotPasswordForm from '../../components/ForgotPasswordForm';
import Helmet from '../../components/common/Helmet';

function ForgotPassword() {
  useEffect(() => {
    document.body.classList.add('new-site', 'forgot');
    return () => {
      document.body.classList.remove('new-site', 'forgot');
    };
  }, []);

  return (
    <>
      <Helmet
        titleTranslationKey="SignInContainerForgotPassword"
        descriptionTranslationKey="ForgotPasswordContainerText"
      />

      <div className="d-flex">
        <Container className="p-0 mt-4">
          <ForgotPasswordForm />
        </Container>
      </div>
    </>
  );
}

export default withLocalize(ForgotPassword);
